import React, { Component } from "react";

import httpClient from '../../httpClient'
import { Button, Modal, ModalBody,Form, FormGroup, Input } from 'reactstrap';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modalLogin: true,
          modalSignup: false,
          modalPRO:this.props.form ||  false,
          fields: {email: '', password: ''}
    
        };
    
        this.togglePRO = this.togglePRO.bind(this);
        
      }

      togglePRO() {
        this.setState({
          modalLogin:false,
          modalSignup: false,
          modalPRO: !this.state.modalPRO
        });
      }


      onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
		})
    }

    onFormSubmitPRO(evt) {
		evt.preventDefault()
		httpClient.logIn(this.state.fields).then(user => {
      this.setState({ fields: { email: '', password: '' } })
      if(user.B2b){
        this.props.onLoginSuccess(user)
      this.props.history.push(`/admin`);
      }
			if(user) {
        this.props.onLoginSuccess(user)
        this.setState({
          modalLogin: false,
          modalSignup:false,
          modalPRO:false
        });
			}
		})
    }
    

    toogleClose = () =>{
      this
      .props
      .dispatch({type: "CLOSING_MODAL"})
  }
  
  openSignUpForm = () =>{
    this
    .props
    .dispatch({type: "SIGNUP_FORM"})
  }
  openSignUpProForm = () =>{
    this
    .props
    .dispatch({type: "SIGNUP_PRO_FORM"})
  }

  render() {
    const {name, password } = this.state.fields

    return (
        <div>
        <Modal isOpen={this.props.pro} toggle={this.toogleClose} className={this.props.className}>
          {/* <ModalHeader toggle={this.toggle}>Modal title</ModalHeader> */}
          <img src='imgs/logo/Group_83.svg' alt='logo' className="logo-login-modal"  />
          <ModalBody>
            <Form className="form-login" onChange={this.onInputChange.bind(this)} onSubmit={this.onFormSubmitPRO.bind(this)} style={{marginBottom:"10px"}}>
            <FormGroup>
                <span className="circle-Pro" type="button"><span className="text-Pro">PRO</span></span>
            </FormGroup>
            <div className="title-center">Connectez-vous</div>

              <FormGroup>
                <Input type="email" name="email" id="exampleEmail" placeholder="Adress e-mail" className="placeholder-center" value={name}></Input>
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Mot de passe" value={password}/>
              </FormGroup>
              <FormGroup>

              <Button className="submit-button" style={{backgroundColor:"#39296a",marginBottom:"107px",borderRadius:"11px"}}>Se Connecter</Button>
              <div className="title-center">vous etes nouveau?</div>

              <Button className="submit-button" style={{backgroundColor:"#00A706",marginBottom:"17px",borderRadius:"11px"}}
              >
                Voir nos plans PRO</Button>
              </FormGroup>
              <FormGroup>
                <span className="circle-Pro" type="button"><span className="text-Pro">PRO</span></span>
              </FormGroup>


            </Form>
            </ModalBody>
          </Modal>
          </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    /*
    login: state.counterApp.login,
    signUp:state.counterApp.signUp,
    pro:state.counterApp.pro
    */
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(LoginForm));